import { Component } from 'react'
import styled, { withTheme } from 'styled-components'

import * as cardUtilities from '@/utilities/client-components/utilities/cardUtilities'

import Actions from './Actions'
import withSpacing from './WithSpacing'

const StyledActionSet = styled.div`
  margin-left: ${(props: any) => -props.theme.spacing.padding}px;
  margin-right: ${(props: any) => -props.theme.spacing.padding}px;
`

interface ActionSetProps {
  actionHandler(...args: unknown[]): unknown
  actions: {
    type: 'Action.Submit' | 'Action.ShowCard' | 'Action.OpenUrl'
    body?: string
    headers?: object
    data?: object
    method?: 'POST' | 'PUT' | 'DELETE' | 'GET'
    url?: string
    title: string
    card?: {
      items?: unknown[]
    }
  }[]
  disabled?: boolean
  format?: 'normal' | 'outline'
  theme?: object
}

class ActionSet extends Component<ActionSetProps> {
  static displayName = 'ActionSet'
  static defaultProps = {
    format: 'normal'
  }

  render() {
    const { theme, actions, format } = this.props
    return (
      <StyledActionSet>
        <Actions {...this.props} orientation={cardUtilities.getActionOrientation(theme, actions)} format={format} />
      </StyledActionSet>
    )
  }
}

const ActionSetWithSpacing = withSpacing(ActionSet)

export default withTheme(ActionSetWithSpacing)
